const initialState = {
	counter: 0,
	dir: "",
	viewer: false,
	img: ""
}

const GallerieReducer = (state = initialState, action) => {
	switch(action.type) {
		case "UPDATE_GALLERIE_COUNTER":
			return {counter : action.payload}

		case "INCREMENT_GALLERIE_COUNTER": 
			return { ...state, counter: state.counter + 1, dir: action.payload}

		case "DECREMENT_GALLERIE_COUNTER": 
			return { ...state, counter: state.counter - 1, dir: action.payload}

		case "TRIGGER_GALLERIE_VIEWER":
			return {...state, viewer: true, img: action.payload}

		case "HIDE_GALLERIE_VIWER":
			return {...state, viewer:false}

		default:
			return state
	}
}


export default GallerieReducer